import React from "react";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";

import { createBrowserRouter, RouterProvider } from "react-router";

import { routes } from "router/routes";

import { persistor, store } from "./store/store";
import { AuthProvider } from "./utils/user-provider";
const router = createBrowserRouter(routes);

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}></PersistGate>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </Provider>
  );
};

export default App;
